import * as Highcharts from 'highcharts'
import 'highcharts/highcharts-more'
import 'highcharts/modules/stock'
import 'highcharts/modules/solid-gauge'
import 'highcharts/modules/boost'
import 'highcharts/modules/heatmap'
import 'highcharts/modules/exporting'
import 'highcharts/modules/export-data'
import 'highcharts/modules/pareto'
import 'highcharts/modules/offline-exporting'
import { getHighchartsOptions } from '@/assets/highcharts_options.js'

export function setupHighcharts() {
  const options = getHighchartsOptions()
  Highcharts.setOptions(options)
}
